import { X } from "lucide-react";
import { Badge } from "../../../ui/badge";
import { Button } from "../../../ui/button";
import { TagItemProps } from "../types";
import { cn } from "../../../utils";

export const TagItem = ({
  label,
  id,
  onRemoveTag,
  disabled,
  className,
  variant = "neutral",
}: TagItemProps) => {
  return (
    <Badge
      variant={variant}
      disabled={disabled}
      size="sm"
      className={cn(
        "flex items-center gap-1 px-2 py-0.5",
        "font-normal whitespace-nowrap",
        className,
      )}
    >
      {label}
      {onRemoveTag && (
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="p-0 size-2.5 text-inherit"
          onClick={e => {
            e.stopPropagation();
            onRemoveTag?.(id);
          }}
          aria-label={`Remove ${label}`}
          disabled={disabled}
        >
          <X className="size-2.5" />
        </Button>
      )}
    </Badge>
  );
};
